import React from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import AdminLayout from "../layouts/Admin";
import AuthLayout from "../layouts/Auth";
import DefaultLayout from "../layouts/Default";

import Page404 from "../pages/auth/Page404";
import Page500 from "../pages/auth/Page500";

import { authRoutes, adminRoutes } from ".";
import Page401 from "../pages/auth/Page401";

const CustomRoutes = () => {
  return (
    <Router>
      <Routes>
        {authRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact
            element={
              <AuthLayout>
                <route.component />
              </AuthLayout>
            }
          />
        ))}
        {adminRoutes.flatMap((route, index) =>
          route.entries
            ? route.entries.map((entry, index) => (
                <Route
                  key={index}
                  path={entry.path}
                  exact
                  element={
                    <AdminLayout {...entry}>
                      <entry.component />
                    </AdminLayout>
                  }
                />
              ))
            : [
                <Route
                  key={index}
                  path={route.path}
                  exact
                  element={
                    <AdminLayout {...route}>
                      <route.component />
                    </AdminLayout>
                  }
                />,
              ]
        )}
        <Route path={"/"} exact element={<Navigate to="/work-orders/all" />} />
        <Route
          path={"/error/500"}
          exact
          element={
            <DefaultLayout>
              <Page500 />
            </DefaultLayout>
          }
        />
        <Route
          path={"/error/404"}
          exact
          element={
            <DefaultLayout>
              <Page404 />
            </DefaultLayout>
          }
        />
        <Route
          path={"/error/401"}
          exact
          element={
            <DefaultLayout>
              <Page401 />
            </DefaultLayout>
          }
        />
        <Route
          path={"*"}
          element={
            <DefaultLayout>
              <Page404 />
            </DefaultLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default CustomRoutes;
